require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-oberpullendorf-kaisersdorf.json") })
        }
      }, "path---betreuungseinrichtungen-oberpullendorf-kaisersdorf");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-oberpullendorf-kaisersdorf!./.cache/json/betreuungseinrichtungen-oberpullendorf-kaisersdorf.json
// module id = 976
// module chunks = 231608221292675